import React, { useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineRestaurantMenu} from 'react-icons/md';
import { motion} from 'framer-motion'
import { Link } from 'react-scroll';

import images from '../../constants/images';
import './Navbar.css';

const Navbar = () => {

  const [toggleMenu, setToggleMenu] = useState(false)

  return (


      <div className='app__navbar'>
      <div className="div w-[80%] sm:w-[90%] m-auto flex flex-row items-center justify-between relative">


        <motion.div
        whileInView={{y: [-50, 0], opacity: [0,1]}}
        transition={{duration: 0.8}}
        
        
         className="app__navbar-logo">
          <img
          
          
           src={images.gericht} alt="app logo" />
        </motion.div>
         <motion.ul
          whileInView={{y: [-20, 0], opacity: [0,1]}}
           transition={{duration: 0.8}}
         
          className='app__navbar-links'>
          <Link spy={true} to="home" smooth={true} activeClass="true">
          <li className="p__opensans">Home</li>

          </Link>
          <Link spy={true} to="about" smooth={true}>
          <li className="p__opensans">About</li>

          </Link>
          <Link spy={true} to="menu" smooth={true}>
          <li className="p__opensans">Menu</li>

          </Link>
          <Link spy={true} to="award" smooth={true}>
          <li className="p__opensans">Awards</li>

          </Link>
          <Link spy={true} to="contact" smooth={true} >

          <li className="p__opensans">Contact</li>
          </Link>
        </motion.ul>
        <motion.div
         whileInView={{y: [-50, 0], opacity: [0,1]}}
        transition={{duration: 0.8}}
         className="app__navbar-login">
          <a href="#login" className='p__opensans'>Log in / Register</a>
          <div />
          <a href="/" className='p__opensans'>Book a Table</a>
        </motion.div>
        <div className="app__navbar-smallscreen w-[80%] relative">
          <GiHamburgerMenu color="#fff" fonSize={27} onClick={() => setToggleMenu(true)} className='absolute right-0'/>

          {toggleMenu && (
          <div className="app__navbar-smallscreen_overlay flex__center slide-bottom ">
            <MdOutlineRestaurantMenu fontSize={27} className="overlay__close right-0 top-4 mt-4 mr-3" onClick={() => setToggleMenu(false)}  />
              <ul className='app__navbar-smallscreen-links'>
              <Link spy={true} to="home" smooth={true} activeClass="true">
          <li className="p__opensans" onClick={() => setToggleMenu(false)}>Home</li>

          </Link>
            <Link spy={true } to='about' smooth={true}>
                <li className="p__opensans overflow-hidden" onClick={() => setToggleMenu(false)}>About</li>

            </Link>
            <Link spy={true } to='menu' smooth={true}>
              
                <li className="p__opensans overflow-hidden" onClick={() => setToggleMenu(false)}>Menu</li>
              </Link>
              <Link spy={true } to='award' smooth={true}>
              
                <li className="p__opensans overflow-hidden" onClick={() => setToggleMenu(false)}>Awards</li>
              </Link>
              <Link spy={true } to='contact' smooth={true}>
                <li className="p__opensans overflow-hidden" onClick={() => setToggleMenu(false)}>Contact</li>
              
              </Link>
              </ul>
          </div>

          )}


        </div>
      </div>
      </div>
  )
};

export default Navbar;
